//* teamName을 얻는 함수

import { User, WorkerUser } from '@shared/api/user/user.interface';

export const getAgencyWorkerTeamName = (
  user: User | WorkerUser | Pick<User, '_id' | 'info' | 'bugoAgencyWorkerDetail'>,
) => {
  if (user.bugoAgencyWorkerDetail?.teamName || user.bugoAgencyWorkerDetail?.teamType) {
    if (user.bugoAgencyWorkerDetail.teamName === user.bugoAgencyWorkerDetail.teamType) {
      return user.bugoAgencyWorkerDetail.teamType;
    } else {
      return (
        user.bugoAgencyWorkerDetail.teamType +
        '(' +
        user.bugoAgencyWorkerDetail.teamName +
        ')'
      );
    }
  } else {
    return '';
  }
};

//* 정산 화면·엑셀용 지도사 표기 — 닉네임(bugoAgencyWorkerDetail.nickName, 동명이인 구분용)이 있으면
//* 닉네임, 없으면 실명. 부고 문자·알림톡 등 고객에게 나가는 곳은 실명(info.name)만 쓴다.
export const getWorkerDisplayName = (
  user?: {
    info?: { name?: string };
    bugoAgencyWorkerDetail?: { nickName?: string };
  } | null,
): string | undefined => user?.bugoAgencyWorkerDetail?.nickName?.trim() || user?.info?.name;

//* 서버가 평탄화해 내려주는 행(workerName + workerNickName)의 지도사 표기 — 규칙은 getWorkerDisplayName과 동일
export const pickWorkerName = (r: {
  workerName?: string;
  workerNickName?: string;
}): string | undefined => r.workerNickName?.trim() || r.workerName;
